import { Languages, SubmissionType } from "@cs124/questioner-types";
import { Number, Record, String } from "runtypes";
export const CacheKey = Record({
  backendVersion: String,
  questionHash: String,
  language: Languages,
  submissionType: SubmissionType,
  submissionHash: String
});
export const CacheStats = Record({
  hits: Number,
  misses: Number
});
//# sourceMappingURL=cache.js.map
